import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import { Button, Icon } from 'components/shared';
import { FormFlex, FormBox, FormGroupAdapter, SelectStateAdapter } from 'components/shared/form';

import { getName, validateRequired } from 'utils';
import styled from 'styled-components';

const propTypes = {
  areComponentsRendered: PropTypes.bool.isRequired,
  setAreComponentsRendered: PropTypes.func.isRequired,
  namespace: PropTypes.string,
  refs: PropTypes.shape({
    statesCollection: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  isFormDisabled: PropTypes.bool,
};

const defaultProps = {
  namespace: null,
  refs: {
    statesCollection: [],
  },
  isFormDisabled: false,
};

const formBoxThreeColumns = [1, 1, 1 / 3];

function AddressFieldsPayment({
  isFormDisabled,
  namespace,
  refs,
  areComponentsRendered,
  setAreComponentsRendered,
}) {
  return (
    <Fragment>
      <FormFlex>
        <ShowHideComponentsButtonBox width={[1, 1, 1]}>
          <ShowHideComponentsButton onClick={() => setAreComponentsRendered(!areComponentsRendered)}>
            {areComponentsRendered ? 'Hide Components' : 'Show Components'}
            {areComponentsRendered ? <AngleUp /> : <AngleDown />}
          </ShowHideComponentsButton>
        </ShowHideComponentsButtonBox>
      </FormFlex>

      <HiddenFieldsContainer isVisible={areComponentsRendered}>
        <FormFlex>
          <StyledFormBox pl={150} width={formBoxThreeColumns}>
            <Field
              name={getName(namespace, 'streetName')}
              required
              label="Street Name"
              disabled={isFormDisabled}
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </StyledFormBox>
          <StyledFormBox width={formBoxThreeColumns}>
            <Field
              name={getName(namespace, 'municipality')}
              required
              label="City"
              disabled={isFormDisabled}
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </StyledFormBox>
          <StyledFormBox pr={150} width={formBoxThreeColumns}>
            <Field
              name={getName(namespace, 'stateCode')}
              namespace={namespace}
              required
              type="select"
              isDisabled={isFormDisabled}
              options={refs.statesCollection}
              label="State"
              validate={validateRequired()}
              component={SelectStateAdapter}
            />
          </StyledFormBox>
        </FormFlex>

        <FormFlex>
          <StyledFormBox pl={150} width={formBoxThreeColumns}>
            <Field
              name={getName(namespace, 'postalCode')}
              required
              label="ZIP"
              disabled={isFormDisabled}
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </StyledFormBox>
          <StyledFormBox pr={150} width={formBoxThreeColumns}>
            <Field
              name={getName(namespace, 'countryCode')}
              required
              label="Country Code (US)"
              disabled={isFormDisabled}
              validate={validateRequired()}
              component={FormGroupAdapter}
            />
          </StyledFormBox>
        </FormFlex>
      </HiddenFieldsContainer>
    </Fragment>
  );
}

const ShowHideComponentsButtonBox = styled(FormBox)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
`;

const HiddenFieldsContainer = styled.div`
  display: ${props => props.isVisible ? 'block' : 'none'};
  transition: opacity 0.3s ease-in-out;
  opacity: ${props => props.isVisible ? 1 : 0};
`;

const ShowHideComponentsButton = styled(Button).attrs({
  transparent: true,
})`
  height: initial;
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  font-size: var(--font-size-xs);
`;

const AngleUp = styled(Icon).attrs({
  icon: 'angle',
})`
  width: 9px;
  height: 9px;
`;
const AngleDown = styled(Icon).attrs({
  icon: 'angle',
})`
  width: 9px;
  height: 9px;
  transform: rotate(180deg);
`;
const StyledFormBox = styled(FormBox)`
  @media (max-width: 990px) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
`;

AddressFieldsPayment.propTypes = propTypes;
AddressFieldsPayment.defaultProps = defaultProps;

export default AddressFieldsPayment;
